// src/pages/Private/Teacher/AssignmentManagement/GradeSubmissions.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getAssignmentSubmissions, gradeSubmission, getAssignmentById } from '../../../../api/teacherApi';
import './GradeSubmissions.css';

function GradeSubmissions() {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const [assignment, setAssignment] = useState(null);
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [grade, setGrade] = useState('');
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    loadData();
  }, [assignmentId]);

  const loadData = async () => {
    try {
      const [assignmentData, submissionsData] = await Promise.all([
        getAssignmentById(assignmentId),
        getAssignmentSubmissions(assignmentId)
      ]);
      setAssignment(assignmentData);
      setSubmissions(submissionsData);
    } catch (error) {
      console.error('Veri yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGrade = async (submissionId) => {
    if (!grade) {
      alert('Lütfen not girin');
      return;
    }

    try {
      await gradeSubmission(submissionId, parseInt(grade), feedback);
      setSelectedSubmission(null);
      setGrade('');
      setFeedback('');
      loadData();
    } catch (error) {
      console.error('Notlandırma hatası:', error);
    }
  };

  const getStatusClass = (status, dueDate) => {
    if (status === 'graded') return 'graded';
    if (new Date() > new Date(dueDate) && status !== 'submitted') return 'late';
    return 'submitted';
  };

  const getStatusText = (status, dueDate) => {
    if (status === 'graded') return 'Değerlendirildi';
    if (new Date() > new Date(dueDate) && status !== 'submitted') return 'Geç Teslim';
    return 'Teslim Edildi';
  };

  if (loading) return <div className="loading">Yükleniyor...</div>;

  return (
    <div className="grade-submissions">
      <div className="page-header">
        <div>
          <h1>{assignment?.title} - Teslimler</h1>
          <p>{submissions.length} öğrenci teslim yaptı</p>
        </div>
        <button onClick={() => navigate(-1)} className="back-btn">
          ← Geri
        </button>
      </div>

      <div className="submissions-list">
        {submissions.length === 0 ? (
          <div className="empty-state">
            <p>Henüz teslim yapılmamış.</p>
          </div>
        ) : (
          submissions.map(sub => (
            <div key={sub._id} className={`submission-card ${getStatusClass(sub.status, assignment.dueDate)}`}>
              <div className="submission-header">
                <div className="student-info">
                  <h3>{sub.student?.name}</h3>
                  <span className="student-email">{sub.student?.email}</span>
                </div>
                <div className="submission-status">
                  <span className={`status-badge ${sub.status}`}>
                    {getStatusText(sub.status, assignment.dueDate)}
                  </span>
                </div>
              </div>

              <div className="submission-meta">
                <span>Teslim: {new Date(sub.submittedAt).toLocaleString('tr-TR')}</span>
                {sub.gradedAt && (
                  <span>Değerlendirme: {new Date(sub.gradedAt).toLocaleString('tr-TR')}</span>
                )}
              </div>

              {sub.files?.length > 0 && (
                <div className="submission-files">
                  <h4>Teslim Edilen Dosyalar:</h4>
                  {sub.files.map((file, index) => (
                    <a key={index} href={file.fileUrl} target="_blank" rel="noopener noreferrer" className="file-link">
                      📎 {file.fileName}
                    </a>
                  ))}
                </div>
              )}

              {sub.notes && (
                <div className="submission-notes">
                  <h4>Öğrenci Notu:</h4>
                  <p>{sub.notes}</p>
                </div>
              )}

              {sub.grade ? (
                <div className="submission-grade">
                  <h4>Değerlendirme</h4>
                  <div className="grade-info">
                    <span className="grade-value">
                      Not: {sub.grade} / {assignment?.totalPoints}
                    </span>
                    {sub.feedback && <p className="feedback-text">{sub.feedback}</p>}
                  </div>
                </div>
              ) : (
                <button 
                  className="grade-btn"
                  onClick={() => setSelectedSubmission(sub)}
                >
                  Not Ver
                </button>
              )}

              {selectedSubmission?._id === sub._id && (
                <div className="grade-form">
                  <h4>Notlandır</h4>
                  <input
                    type="number"
                    placeholder={`Not (0-${assignment?.totalPoints})`}
                    value={grade}
                    onChange={(e) => setGrade(e.target.value)}
                    max={assignment?.totalPoints}
                    min="0"
                  />
                  <textarea
                    placeholder="Geri bildirim (isteğe bağlı)"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    rows="3"
                  />
                  <div className="grade-actions">
                    <button onClick={() => handleGrade(sub._id)} className="save-grade">
                      Kaydet
                    </button>
                    <button onClick={() => setSelectedSubmission(null)} className="cancel-grade">
                      İptal
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default GradeSubmissions;